import React from "react";


import { useNavigate } from 'react-router-dom';
import { useGuestStore } from "src/App";
import lockIcon from '../asset/images/new/lock.png'


const LogOutComponent = () => {


    const navigate = useNavigate('/')

    const handleLogout = () => {
        useGuestStore.setState({ id: "" })
        useGuestStore.setState({ name: "" })
        useGuestStore.setState({ phone: "" })
        navigate('/guest-login')
    }



    return (

      <div className="d-flex justify-content-center">
        <button className='logout-btn' onClick={handleLogout}>
          <img className='lock-icon' src={lockIcon} alt="" /> Log Out
        </button>
      </div>
    )
}


export default LogOutComponent;